import ShortText from "./Short_Text";
import LongTextField from "./Long_Text";
import NumberField from "./Number";
import SelectField from "./Select";
import MultiSelectField from "./Multi_Select";
import RadioField from "./Radio";
import CheckboxField from "./Checkbox";
import DateField from "./Date";

export const getFieldComponent = (fieldTypeId: number) => {
    switch (fieldTypeId) {
      case 1:
        return ShortText;
      case 2:
        return LongTextField;
      case 3:
        return NumberField;
      case 4:
        return DateField;
      case 5:
        return SelectField;
      case 6:
        return MultiSelectField;
      case 7:
        return CheckboxField;
      case 8:
        return RadioField;
      default:
        return null;
    }
  };